module.exports = __webpack_public_path__ + "static/media/Glitch-1.c75e46ab.webp";